import { GetPostRequiredActionsDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'
import AudienceCollection from './AudienceCollection'

type Props = {
  postId: string
}

const PostInsightsContent = ({ postId }: Props) => {
  const { data: postData } = useQuery(GetPostRequiredActionsDocument, {
    variables: { postId },
  })

  const hasRequiredActions = postData?.posts?.post?.hasRequiredActions ?? false

  return <AudienceCollection postId={postId} hasRequiredActions={hasRequiredActions} />
}

export default PostInsightsContent
